







































































































import BaseComponent from '@/components/base-component.vue';
import PlannerFilters from '@/components/crm/adm-planner/planner-filters.vue';
import PlannerItemForm from '@/components/crm/adm-planner/planner-item-form.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiTableContainer from '@/components/UI/table-container.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { PaginationSyncDTO, ResultPagDTO } from '@/interfaces/base-dto';
import { ItemAgendaFiltroDTO } from '@/interfaces/crm-planner';
import * as service from '@/services/crm-planner';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiFilterContainer,
    UiTableContainer,
    UiToggleStatus,
    PlannerItemForm,
    PlannerFilters
  }
})
export default class PlannerItem extends BaseComponent {
  public formOpen: boolean = false;
  public edit: boolean = false;

  idSelected = null;
  filter: any = {};

  items = [];
  pagination: PaginationSyncDTO = new PaginationSyncDTO();
  pagina: ResultPagDTO<any> = new ResultPagDTO();
  loading = false;
  error = false;

  public headers: any = [
    { text: 'Data / Período', value: 'dataIni', sortable: true },
    { text: 'Tipo', value: 'tipo.descricao', sortable: true },
    { text: 'Colaborador', value: 'p.usuario.nome', sortable: true },
    { text: 'Alterado por', value: 'loginAlteracao', sortable: true },
    { text: 'Alterado em', value: 'dataAlteracao', sortable: true },
    { text: '', value: '', sortable: false, width: '30' }
  ];

  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  mounted() {
    this.load();
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return service.listCrmPlannerItems(filter);
        })
      )
      .subscribe(
        (res) => {
          this.items = res.content;
          this.loading = false;
          this.pagina = res;
          PaginationSyncDTO.update(this.pagination, res);
        },
        (error) => {
          this.loading = false;
          this.showToastApiError(error);
        }
      );
  }

  newItem() {
    this.idSelected = null;
    this.formOpen = true;
    this.edit = true;
  }

  openItem(item, edit) {
    this.idSelected = item.id;
    this.formOpen = true;
    this.edit = edit;
  }

  onCloseForm() {
    this.formOpen = false;
  }

  onAfterSave(res) {
    this.formOpen = false;
    this.load();
  }

  public onFilter(value): void {
    this.filter = value;
    this.pagination.page = 1;
    if (this.filter.sortBy) {
      this.pagination.descending = this.filter.descending;
      this.pagination.sortBy = this.filter.sortBy;
    }
    this.load();
  }

  onChangeFilter() {
    this.load();
  }

  load() {
    this.items = [];
    this.loading = true;

    let parm = new ItemAgendaFiltroDTO();
    parm.idsTipos = this.filter.idsTipos;
    parm.dataIni = this.filter.datas && this.filter.datas.length == 2 ? this.filter.datas[0] : null;
    parm.dataFim = this.filter.datas && this.filter.datas.length == 2 ? this.filter.datas[1] : null;
    parm.idsParticipantes = this.filter.idsParticipantes;
    parm.update(this.pagination);
    this.execBehaviorSub$.next(parm);
  }

  @Watch('pagination')
  private onChangePagination() {
    this.load();
  }

  public deleteItem(item): void {
    const deleteAction = () => {
      this.loader.start('Processando... ');
      service.deleteCrmPlannerItem(item.id).subscribe(
        (res) => {
          this.loader.stop();
          this.toast.show('Item excluído com sucesso', 'success');
          this.load();
        },
        (error) => {
          this.loader.stop();
          this.showToastApiError(error);
        }
      );
    };

    this.dialog.show(
      'error',
      'Confirme a Exclusão',
      `Deseja excluir ${item.tipo}, ${item.periodo}?`,
      'Voltar',
      '',
      'Excluir',
      deleteAction
    );
  }
}
